import { DataTableSearchService } from "aes-datatables";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SenetData } from "aes-datatables";
import { Injectable } from "@angular/core";
import { CRUDService, Message } from "aes-common";

export interface HTTPConnection {
    connectionId: number;
    creationDate: string;
    host: string;
    username: string;
    passwordEnc: string;
    header1: string;
    value1Enc: string;
    header2: string;
    value2Enc: string;
    dataType: string;
    https: boolean;
    port: number;
    downlinkPath: string;
    method: string;
    acctId: number;
}
@Injectable()
export class AESHTTPConnectionService implements DataTableSearchService<HTTPConnection>, CRUDService<HTTPConnection>{

    constructor(private http: HttpClient) { }

    create(object: HTTPConnection): Observable<Message> {
        const href = 'connections';
        var params = new HttpParams().set("connectionType", "HTTP");
        var requestUrl = `${href}`

        return this.http.post<Message>(requestUrl, object, {
            params : params
        });
    }
    edit(object: HTTPConnection): Observable<Message> {
        const href = 'connections';
        var params = new HttpParams().set("connectionType", "HTTP");
        var requestUrl = `${href}`

        return this.http.put<Message>(requestUrl, object, {
            params : params
        });
    }
    delete(object: HTTPConnection): Observable<Message> {
        const href = 'connections';
        var params = new HttpParams().set("connectionType", "HTTP").set("connectionId", object.connectionId.toString());
        var requestUrl = `${href}`

        return this.http.delete<Message>(requestUrl, {
            params : params
        });
    }

    search(sort: string, order: string, page: number, search: string, limit: number, customFilter: any): Observable<SenetData<HTTPConnection>> {
        const href = 'connections';
        var offset = page * limit
        var requestUrl = `${href}`;

        var params = new HttpParams().set("connectionType", "HTTP");
        var requestUrl = `${href}`;
        if(sort != undefined && sort != ""){
            params = params.set("sort", sort);
        }
        if(!isNaN(limit)){
            params = params.set("limit", limit.toString());
        }
        if(order != undefined){
            params = params.set("sortDir", order);          
        }
        if(!isNaN(offset)){
            params = params.set("offset", offset.toString());
        }
        if (search != undefined && search != "") {
            params = params.set("search", search);
        }

        if(customFilter && customFilter.acctId != undefined){
            params = params.set("acctId", customFilter.acctId);
        }

        return this.http.get<SenetData<HTTPConnection>>(requestUrl, {
            params : params
        });
    }
}